const CancelablePromise = require('mn-utils/CancelablePromise');
const getTime = require('mn-utils/time');
const dynamicModule = require('mn-utils/browser/dynamicModule');
const dynamic = require('mn-utils/browser/dynamic');
const downloadBase = require('mn-utils/browser/download').base;
const getBase64Image = require('mn-utils/browser/getBase64Image');
const repeat = require('mn-utils/repeat');


const modulePdfMake = module.exports = dynamicModule((options) => {
  return dynamic('./pdfMake.js', {
    query: {
      t: +new Date(),
    },
  }).then(() => {
    return window.pdfMake;
  });
});


modulePdfMake.exportPDF = exportPDF;
modulePdfMake.makePDF = makePDF;

const MAKE_PDF_OPTIONS = modulePdfMake.MAKE_PDF_OPTIONS = {
  getBase64Image,
  getLunuLogo,
  exportPDF,
  exportLunuPDF,
  separator,
  line(name, value) {
    return {
      margin: [0, 0, 0, 15],
      columns: [
        {
          width: 90,
          text: name,
          fontSize: 8,
        },
        {
          width: 150,
          text: value,
          fontSize: 8,
        },
      ],
    };
  },
};

function getLunuLogo() {
  return getBase64Image('./lunu.png');
}
function separator() {
  return {
    margin: [0, 0, 0, 15],
    text: repeat('- ', 57),
    fontSize: 8,
  };
}
function exportLunuPDF(content) {
  return getLunuLogo().then((dataUrl) => {
    return exportPDF({
      params: {
        pageSize: {
          width: 320,
          height: 'auto',
        },
        content: [
          {
            image: dataUrl,
            width: 80,
            margin: [0, 0, 0, 35],
          },
          separator(),
          ...content,
        ],
      },
    });
  });
}
function makePDF(callback) {
  return CancelablePromise.resolve(callback(MAKE_PDF_OPTIONS));
}
function exportPDF(options) {
  return modulePdfMake().then((pdfMake) => {
    return new CancelablePromise((resolve, reject) => {
      let _stop;
      pdfMake.createPdf(options.params).getBlob((blob) => {
        _stop || resolve(downloadBase(
            URL.createObjectURL(blob),
            options.downloadFileName || `${getTime()}.pdf`,
        ));
      });
      return () => {
        _stop = 1;
      };
    });
  });
}
